<template>
  <div></div>
</template>

<script>
export default {
  name: 'ServerWarningModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentIP: {
      type: String,
      default: 'неизвестен'
    },
    expectedIP: {
      type: String,
      default: '178.66.50.117'
    },
    isCurrentIP: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close'],
  methods: {
    closeModal() {
      this.$emit('close');
    },
    refreshPage() {
      window.location.reload(true);
    }
  }
}
</script>

<style scoped>
kbd {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.75rem;
}

/* Анимация появления */
.scale-100 {
  animation: modalAppear 0.3s ease-out;
}

@keyframes modalAppear {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style> 